import { create } from 'zustand';

interface UseAccountSelectStore {
  data: boolean;
  toggleAccountsSelect: () => void;
}

export const useAccountSelectStore = create<UseAccountSelectStore>((set, get) => ({
  data: false,

  toggleAccountsSelect: () => set({ data: !get().data }),
}));
